<template>
   <div class="col-md-3 col-lg-2 d-md-block bg-light sidebar">
        <NavPlantTypesSidebar v-if="allPlantTypes" v-bind="currentPlantTypesProperties" 
            v-on:setType="setType" v-on:newType="newType" v-on:editType="editType"
            v-on:editEvaluation="editEvaluation" v-on:newEvaluation="newEvaluation" v-on:setEvaluation="setEvaluation"></NavPlantTypesSidebar>
    </div>
    <div class="col-md-9 ms-sm-auto col-lg-10">
        <component :is="currentTabComponent" v-if="this.currentEvaluation" v-bind="currentProperties"></component>
    </div>
    <button id="modalOpen" style="display:none;" class="btn btn-sm btn-primary" data-bs-toggle="modal" data-bs-target="#modalPlantTypeEval" aria-hidden="true">hidden</button>
    <div class="modal fade" id="modalPlantTypeEval" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalLabel">{{ $t(this.currentComponent) }}</h5>
                    <button type="button" id="modalPlantTypeEvalClose" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body modal-textarea">
                    <component v-if="allPlantTypes" :is="currentComponent" v-bind="currentModalProperties" v-on:closeModal="closeModal"></component>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t("close") }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    
import NavPlantTypesSidebar from '@/components/navs/NavPlantTypesSidebar.vue'
import AddEvaluation from '@/components/PlantTypes/AddEvaluation'
import EditEvaluation from '@/components/PlantTypes/EditEvaluation'
import EditEvaluationColumns from '@/components/PlantTypes/EditEvaluationColumns'
import axios from 'axios'
export default {
    name: 'PlantTypeEvaluations',
    components: {
        NavPlantTypesSidebar,
        AddEvaluation,
        EditEvaluation,
        EditEvaluationColumns
    },
    data() {
        return {
            currentType: "",
            currentEvaluation: "",
            allPlantTypes: "",
            currentTabComponent: "EditEvaluationColumns",
            currentComponent: "AddType"
        }
    },
    mounted(){
        this.getPlantTypes()
    },
    updated(){
        console.log('updated')
        
    },
    unmounted(){
        console.log('component unmounted')
        
        
    },
    methods: {
        newEvaluation(type){
            console.log('entry newEvaluation')
            this.currentComponent = "AddEvaluation"
            document.getElementById('modalOpen').click();
            console.log('exit newEvaluation')
        },
        setEvaluation(type, evaluation){
            console.log('entry setEvaluation')
            this.currentEvaluation = evaluation
            this.currentType = type
            console.log('exit setEvaluation')
        },
        editEvaluation(evaluation){
            console.log('entry editEvaluation')
            this.currentEvaluation = evaluation
            this.currentComponent = "EditEvaluation"
            console.log('exit editEvaluation    ')
        },
        editType(type){
            console.log('entry editType')
            this.currentType = type
            this.currentComponent = "EditType"
            document.getElementById('modalOpen').click();
            console.log('exit editType')
        },
        closeModal(action, data){
            console.log('entry closeModal with action: ' + action)
            document.getElementById('modalPlantTypeEvalClose').click();
            if(action === 'add'){
                this.currentType.plant_type_evaluations.push(data)
            }
            console.log('exit closeModal')
        },
        newType(){
            console.log('entry newType')
            this.currentComponent = "AddType"
            document.getElementById('modalOpen').click();
            console.log('exit newType')
        },
        setType(type){
            console.log('entry setType')
            console.log(type)
            this.currentType = type
            console.log('exit setType')
        },  
        getPlantTypes(){
            console.log('entry getPlantTypes')
             axios
                .get('/api/v1/planttypes/')
                .then(response => {
                    this.allPlantTypes = response.data
                    console.log('planttypes fertig geladen')
                })
                .catch(error => {
                    if (error.response) {
                        if ('detail' in error.response.data){
                            createToast({text: this.$t(error.response.data['detail'])
                                        ,type: 'error'})
                        }                        
                        console.error(JSON.stringify(error.response.data))
                    } else if (error.message) {
                        console.error(JSON.stringify(error.message))
                    } else {
                        console.error(JSON.stringify(error))
                    }
                })
            console.log('exit getPlantTypes')
        },
         
    },
    computed:{
        plantsLoaded(){
            if(this.$store.getters.getPlants){
                return true
            }
            return false
        },
        organisation(){
            return this.$store.getters.getOrganisation
        },
   
        currentPlantTypesProperties(){
                return {plantTypes: this.allPlantTypes,
                    editPlantType: false,
                    showTypEvaluation: true,
                    createEvaluation: true}
            },
        currentProperties(){
                return {evaluationId: this.currentEvaluation.id}
            },
        currentModalProperties(){
                return {plantType: this.currentType,
                    evaluation: this.currentEvaluation}
            },
    }
}
</script>
